import { CommonStatusEnum } from '@bo-client/activation-management/shared/models/commissioningModel';

export enum GridRegistrationTypeEnum {
  Feeder = 'Feeder',
  Charger = 'Charger',
  EHeating = 'EHeating',
  Misc = 'Misc',
  PlugInProducer = 'PlugInProducer',
  Storage = 'Storage',
  ChangeMeteringConcept = 'ChangeMeteringConcept'
}

export const GridRegistrationTypeConst = [
  {
    value: GridRegistrationTypeEnum.Feeder,
    displayName: 'Einspeiseranlage',
    imgUrl: 'c:/upload/Messkonzept2.png'
  },
  {
    value: GridRegistrationTypeEnum.Charger,
    displayName: 'Ladeeinrichtung',
    imgUrl: 'c:/upload/Messkonzept2.png'
  },
  {
    value: GridRegistrationTypeEnum.Storage,
    displayName: 'Speicher',
    imgUrl: 'c:/upload/Messkonzept2.png'
  },
  {
    value: GridRegistrationTypeEnum.EHeating,
    displayName: 'E-Heizung / Wärmepumpe / Raumkühlanlage',
    imgUrl: 'c:/upload/Messkonzept2.png'
  },
  {
    value: GridRegistrationTypeEnum.Misc,
    displayName: 'Sonstige Verbraucher',
    imgUrl: 'c:/upload/Messkonzept2.png'
  },
  {
    value: GridRegistrationTypeEnum.PlugInProducer,
    displayName: 'Steckerfertige Erzeugungsanlage',
    imgUrl: 'c:/upload/Messkonzept2.png'
  },
  {
    value: GridRegistrationTypeEnum.ChangeMeteringConcept,
    displayName: 'Messkonzeptwechsel',
    imgUrl: 'c:/upload/Messkonzept2.png'
  }
];

export enum ConsumerDeviceTypeEnum {
  DEVICE1 = 'DEVICE1',
  DEVICE2 = 'DEVICE2'
}

export const ConsumerDeviceTypeConst = [
  {
    value: ConsumerDeviceTypeEnum.DEVICE1,
    displayName: 'DEVICE1'
  },
  {
    value: ConsumerDeviceTypeEnum.DEVICE2,
    displayName: 'DEVICE2'
  }
];

export enum FeedingPlantTypeEnum {
  New = 'New',
  Extension = 'Extension'
}

export enum GridRegistrationStatus {
  PlaceInServiceConfirmationRequest = 'PlaceInServiceConfirmationRequest',
  PlacedInServiceConfirmation = 'PlacedInServiceConfirmation',
  WaitingForCustomerFeedInOrder = 'WaitingForCustomerFeedInOrder',
  ConfiguringFeedInManagement = 'ConfiguringFeedInManagement',
  PendingAssignTechnician = 'PendingAssignTechnician',
  NeedMeterChange = 'NeedMeterChange',
  Declined = 'Declined',
  Expired = 'Expired'
}

export const GridRegistrationStatusEnum = {
  ...CommonStatusEnum,
  ...GridRegistrationStatus
};

export const FeedingPlantTypeConst = [
  {
    value: FeedingPlantTypeEnum.New,
    displayName: 'Neueinrichtung'
  },
  {
    value: FeedingPlantTypeEnum.Extension,
    displayName: 'Erweiterung'
  }
];

export enum PowerGenerationSourceEnum {
  PhotoVoltaic = 'PhotoVoltaic',
  Wind = 'Wind',
  Water = 'Water',
  BioGas = 'BioGas',
  NaturalGas = 'NaturalGas',
  Misc = 'Misc'
}

export enum MeterOperatorEnum {
  gridOperator = 'gridOperator',
  competitiveMeterOperator = 'competitiveMeterOperator'
}

export const MeterOperatorConst = [
  {
    value: MeterOperatorEnum.gridOperator,
    displayName: 'Netzbetreiber'
  },
  {
    value: MeterOperatorEnum.competitiveMeterOperator,
    displayName: 'dritter Messtellenbetreiber'
  }
];

export const PowerGenerationSourceConst = [
  {
    value: PowerGenerationSourceEnum.PhotoVoltaic,
    displayName: 'Solar'
  },
  {
    value: PowerGenerationSourceEnum.Wind,
    displayName: 'Wind'
  }
];

export enum DevicePlacementTypeEnum {
  building = 'building',
  openSpace = 'openSpace',
  facade = 'facade'
}

export enum PhasesTypeEnum {
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3'
}

export enum ConnectedPhasesTypeEnum {
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  L1L2 = 'L1L2',
  L1L3 = 'L1L3',
  L2L3 = 'L2L3',
  L1L2L3 = 'L1L2L3'
}

export enum GridRegistrationFeederActionTypeEnum {
  commissioning = 'commissioning',
  extension = 'extension',
  change = 'change',
  decommissioning = 'decommissioning',
  sealing = 'sealing',
  changeCommunicate = 'changeCommunicate'
}

export enum FeedInManagementInfoEnum {
  electronicRippleControlReceiverWithProgramming = 'electronicRippleControlReceiverWithProgramming',
  eegBoxWithElectronicRippleControlReceiver = 'eegBoxWithElectronicRippleControlReceiver',
  feedInReduction50 = 'feedInReduction50',
  feedInReduction70 = 'feedInReduction70',
  telecontrolWithProgramming = 'telecontrolWithProgramming',
  telecontrolWithProgramming2 = 'telecontrolWithProgramming2',
  noReduction = 'noReduction',
  controlWithClsFeedInReduction60 = 'controlWithClsFeedInReduction60',
  electronicRippleControlReceiverFI60 = 'electronicRippleControlReceiverFI60'
}

export enum FeedInManagementOrderStateEnum {
  NOT_NEEDED = 'NOT_NEEDED',
  ORDERED = 'ORDERED',
  REQUESTED = 'REQUESTED'
}

export enum CommEventsToChildEnum {
  commissioningSaved = 'commissioningSaved',
  changedGisData = 'changedGisData'
}

export enum SymmetryConditionsEnum {
  ThreePhase = 'ThreePhase',
  DeviceBalancing = 'DeviceBalancing',
  SinglePhaseDistribution = 'SinglePhaseDistribution'
}

export enum NaProtectionTypeEnum {
  Integrated = 'Integrated',
  Centralised = 'Centralised'
}

export enum ReactivePowerProvisioningMethod {
  Q_U_STANDARD_CURVE = 'Q_U_STANDARD_CURVE',
  COS_PHI_P_STANDARD_CURVE = 'COS_PHI_P_STANDARD_CURVE',
  FIXED_DISPLACEMENT_FACTOR_COS_PHI = 'FIXED_DISPLACEMENT_FACTOR_COS_PHI'
}

export enum FeederConnectionStandard {
  VDE4105 = 'VDE4105',
  VDE4110 = 'VDE4110'
}

export enum FeedInCompensationType {
  EEG_COMPENSATION = 'EEG_COMPENSATION',
  NO_COMPENSATION = 'NO_COMPENSATION',
  SUBST_DIRECT_MARKETING = 'SUBST_DIRECT_MARKETING',
  TENANT_ELECTRICITY_SURCHARGE = 'TENANT_ELECTRICITY_SURCHARGE',
  MISC_DIRECT_MARKETING = 'MISC_DIRECT_MARKETING'
}

export enum VoltageLevel {
  Low = 'Low',
  Middle = 'Middle',
  High = 'High'
}

export const VoltageLevelDisplayNames = {
  [VoltageLevel.Low]: 'Niederspannung',
  [VoltageLevel.Middle]: 'Mittelspannung',
  [VoltageLevel.High]: 'Hochspannung'
};
